import Swal from "sweetalert2";
import { GetKey } from "../../../Helpers/GetKey";

const titulo = "Clientes";
const error = "error";
export const ValidaCultivo = (state) => {
  if (state === undefined || state === null) {
    Swal.fire(
      "Clientes",
      "Error interno, favor de comunicarse con el administrador del sistema",
      "error"
    );
    return false;
  }
  if (
    state.idcultivo === undefined ||
    state.idcultivo === null ||
    state.idcultivo === ""
  ) {
    Swal.fire(titulo, "El campo cultivo es obligatorio", error);
    return false;
  }

  if (
    state.terreno === undefined ||
    state.terreno === null ||
    state.terreno === ""
  ) {
    Swal.fire(titulo, "El campo terreno es obligatorio", error);
    return false;
  }
  if (
    state.hectareas === undefined ||
    state.hectareas === null ||
    state.hectareas === ""
  ) {
    Swal.fire(titulo, "El campo hectareas es obligatorio", error);
    return false;
  }

  if (Number(state.hectareas) <= 0) {
    Swal.fire(titulo, "El campo hectareas debe ser un valor mayor a 0", error);
    return false;
  }
  if (
    state.seguro_cosecha === undefined ||
    state.seguro_cosecha === null ||
    state.seguro_cosecha === ""
  ) {
    Swal.fire(titulo, "El campo seguro de cosecha es obligatorio", error);
    return false;
  }
  if (state.ciclo === undefined || state.ciclo === null || state.ciclo === "") {
    Swal.fire(titulo, "El campo ciclo es obligatorio", error);
    return false;
  }
  if (
    state.tipo_riego === undefined ||
    state.tipo_riego === null ||
    state.tipo_riego === ""
  ) {
    Swal.fire(titulo, "El campo tipo de riego es obligatorio", error);
    return false;
  }
  if (
    state.temporal === undefined ||
    state.temporal === null ||
    state.temporal === ""
  ) {
    Swal.fire(titulo, "El campo temporal es obligatorio", error);
    return false;
  }
  if (
    state.rendimiento === undefined ||
    state.rendimiento === null ||
    state.rendimiento === ""
  ) {
    Swal.fire(titulo, "El campo rendimiento es obligatorio", error);
    return false;
  }
  if (
    state.precio === undefined ||
    state.precio === null ||
    state.precio === ""
  ) {
    Swal.fire(titulo, "El campo precio es obligatorio", error);
    return false;
  }
  if (
    state.mescosecha === undefined ||
    state.mescosecha === null ||
    state.mescosecha === ""
  ) {
    Swal.fire(titulo, "El campo mes de cosecha es obligatorio", error);
    return false;
  }

  return {
    idcliente: "",
    registro: "",
    idcultivo: Number(GetKey(state.idcultivo)),
    terreno: GetKey(state.terreno),
    hectareas: Number(state.hectareas),
    seguro_cosecha: GetKey(state.seguro_cosecha),
    ciclo: state.ciclo,
    tipo_riego: GetKey(state.tipo_riego),
    temporal: GetKey(state.temporal),
    rendimiento: Number(state.rendimiento),
    precio: Number(state.precio),
    mescosecha: Number(GetKey(state.mescosecha)),
    estatus: true,
  };
};
